exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-upload__tip[data-v-62f4c554]{\n  margin: 0 0 0.13333rem;\n  line-height: initial;\n}\n", ""]);

// exports
